/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует поток изменений ресурсов домена Телеметрии
 */

/**
 * Сигнал на старт обогащения метаданных индикаторов.
 * Очередь key.telemetry_metric.indicators_metadata_start_task
 */
export type IndicatorsMetadataStartTaskRequestDto = {
}
/**
 * Сигнал на старт обогащения метаданных индикаторов.
 * Очередь key.telemetry_metric.indicators_metadata_start_task
 */
export type IndicatorsMetadataStartTaskResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сигнал на старт обогащения метаданных индикаторов.
   * Очередь key.telemetry_metric.indicators_metadata_start_task
   */
  "IndicatorsMetadataStartTask": {
    "kind": "class",
    "text": "Сигнал на старт обогащения метаданных индикаторов.\nОчередь key.telemetry_metric.indicators_metadata_start_task",
  },
}